import React from "react";
import SendScheduleEditor, {
  ScheduleSettings,
  buildDefaultScheduleSettings,
} from "./SendScheduleEditor";

// Agents store per-channel schedules with a top-level `enabled: false`
// default (agents are 24/7 unless the user opts in). Kept as a named export
// for any callers that need the starting shape.
export const DEFAULT_SCHEDULE_SETTINGS: ScheduleSettings =
  buildDefaultScheduleSettings({ enabled: false });

interface ChannelScheduleProps {
  schedule: any;
  onChange: (schedule: any) => void;
  disabled?: boolean;
  helperText?: string;
}

const ChannelSchedule: React.FC<ChannelScheduleProps> = ({
  schedule,
  onChange,
  disabled = false,
  helperText = "The agent will only respond during the specified time windows on enabled days. Set start time after end time for overnight spans (e.g., 7:00 PM to 6:00 AM).",
}) => {
  const settings = schedule || DEFAULT_SCHEDULE_SETTINGS;

  return (
    <SendScheduleEditor
      value={settings}
      onChange={onChange}
      helperText={helperText}
      disabled={disabled}
      showEnableToggle
      enableToggleLabel="Enable Schedule"
      disabledMessage="Agent is available 24/7 on this channel"
      allowOvernight
      bordered={false}
    />
  );
};

export default ChannelSchedule;
